// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Organisations
 */
/**
 * Authentication provider configured for an organisation.
 */
export type AuthProvider = (typeof AuthProvider)[keyof typeof AuthProvider];

export const AuthProvider = {
  cognito: "cognito",
  cloudentity: "cloudentity",
  unspecified: "unspecified",
} as const;
